import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=af9b1678&"
import script from "./TagEdit.vue?vue&type=script&lang=js&"
export * from "./TagEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af9b1678')) {
      api.createRecord('af9b1678', component.options)
    } else {
      api.reload('af9b1678', component.options)
    }
    module.hot.accept("./TagEdit.vue?vue&type=template&id=af9b1678&", function () {
      api.rerender('af9b1678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagEdit.vue"
export default component.exports